module.exports = __webpack_public_path__ + "img/2.fc866684.jpg";